import { push } from 'react-router-redux';

import { endpoint } from '../../helpers/Endpoints';
import * as FetchAction from '../FetchActionGeneric';

import type { ICustomer, IDistributionCenter } from '../../domain';
import { route } from '../../helpers/Routes';
import type { IToastMessage } from '../../helpers/Toastr';
import { toastr } from '../../helpers/Toastr';

export const SELF_SERVICE_GET_LOCATIONS = '@sss.cm:SELF_SERVICE_GET_LOCATIONS';
export const SELF_SERVICE_GET_LOCATIONS_SUCCESS =
	'@sss.cm:SELF_SERVICE_GET_LOCATIONS_SUCCESS';
export const SELF_SERVICE_GET_LOCATIONS_ERROR =
	'@sss.cm:SELF_SERVICE_GET_LOCATIONS_ERROR';

export const SELF_SERVICE_GET_OPERATING_COMPANIES =
	'@sss.lm:SELF_SERVICE_GET_OPERATING_COMPANIES';
export const SELF_SERVICE_GET_OPERATING_COMPANIES_SUCCESS =
	'@sss.lm:SELF_SERVICE_GET_OPERATING_COMPANIES_SUCCESS';
export const SELF_SERVICE_GET_OPERATING_COMPANIES_ERROR =
	'@sss.lm:SELF_SERVICE_GET_OPERATING_COMPANIES_ERROR';

export function GetOpcosForCustomer(customerId: number) {
	return FetchAction.CreateFetchAction<IDistributionCenter[]>({
		startAction: SELF_SERVICE_GET_OPERATING_COMPANIES,
		method: 'GET',
		url: endpoint.distributionCenters(customerId),
	});
}

export const SELF_SERVICE_GET_CUSTOMER = '@sss.lm:SELF_SERVICE_GET_CUSTOMER';
export const SELF_SERVICE_GET_CUSTOMER_SUCCESS =
	'@sss.lm:SELF_SERVICE_GET_CUSTOMER_SUCCESS';
export const SELF_SERVICE_GET_CUSTOMER_ERROR =
	'@sss.lm:SELF_SERVICE_GET_CUSTOMER_ERROR';

export function GetCustomer(customerId: number) {
	return FetchAction.CreateFetchAction<ICustomer>({
		startAction: SELF_SERVICE_GET_CUSTOMER,
		method: 'GET',
		url: endpoint.getCustomer(customerId),
	});
}

export const SELF_SERVICE_CREATE_LOCATION =
	'@sss.lm:SELF_SERVICE_CREATE_LOCATION';
export const SELF_SERVICE_CREATE_LOCATION_SUCCESS =
	'@sss.lm:SELF_SERVICE_CREATE_LOCATION_SUCCESS';
export const SELF_SERVICE_CREATE_LOCATION_ERROR =
	'@sss.lm:SELF_SERVICE_CREATE_LOCATION_ERROR';

export interface ICreateLocationRequest {
	name: string;
	addressLine1: string;
	addressLine2: string;
	city: string;
	state: string;
	zip: string;
	externalCode: string;
	distributionCenterId: number;
	bidList: string;
	restriction: string;
	override: string;
}

export function CreateLocation(
	customerId: number,
	request: ICreateLocationRequest,
	toastMessage: IToastMessage
) {
	return FetchAction.CreateFetchAction({
		startAction: SELF_SERVICE_CREATE_LOCATION,
		method: 'POST',
		url: endpoint.syscoSelfService.createLocation(customerId),
		body: JSON.stringify(request),
		onAfterSuccess: () => {
			toastr.success(toastMessage);
		},
	});
}

export const SELF_SERVICE_MASS_IMPORT_LOCATIONS =
	'@sss.lm:SELF_SERVICE_MASS_IMPORT_LOCATIONS';
export const SELF_SERVICE_MASS_IMPORT_LOCATIONS_SUCCESS =
	'@sss.lm:SELF_SERVICE_MASS_IMPORT_LOCATIONS_SUCCESS';
export const SELF_SERVICE_MASS_IMPORT_LOCATIONS_ERROR =
	'@sss.lm:SELF_SERVICE_MASS_IMPORT_LOCATIONS_ERROR';

export function SubmitMassImportLocationsRequest(
	customerId: number,
	file: File,
	successMessage: IToastMessage,
	failureMessage: IToastMessage
) {
	const formData: FormData = new FormData();
	formData.append('file', file);
	formData.append('customerId', customerId.toString());

	return FetchAction.CreateFetchAction({
		url: endpoint.locationsMassImportRequest(),
		method: 'POST',
		body: formData,
		startAction: SELF_SERVICE_MASS_IMPORT_LOCATIONS,
		onAfterSuccess: (
			payload,
			dispatch,
			getState,
			httpResponseStatus,
			value
		) => {
			if (value.statusCode === 502) {
				toastr.error(failureMessage);
			} else {
				toastr.success(successMessage);
				dispatch(push(route.syscoSelfService.manageLocations(customerId)));
			}
		},
	});
}

export const SELF_SERVICE_MASS_IMPORT_LOCATIONS_IN_PROGRESS =
	'@sss.lm:SELF_SERVICE_MASS_IMPORT_LOCATIONS_IN_PROGRESS';
export const SELF_SERVICE_MASS_IMPORT_LOCATIONS_IN_PROGRESS_SUCCESS =
	'@sss.lm:SELF_SERVICE_MASS_IMPORT_LOCATIONS_IN_PROGRESS_SUCCESS';
export const SELF_SERVICE_MASS_IMPORT_LOCATIONS_IN_PROGRESS_ERROR =
	'@sss.lm:SELF_SERVICE_MASS_IMPORT_LOCATIONS_IN_PROGRESS_ERROR';

export function GetMassImportInProgressForCustomer(customerId: number) {
	return FetchAction.CreateFetchAction({
		url: endpoint.locationsMassImportInProgressForCustomer({ customerId }),
		startAction: SELF_SERVICE_MASS_IMPORT_LOCATIONS_IN_PROGRESS,
	});
}
